/* import __COLOCATED_TEMPLATE__ from './team-selector.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { SearchableType } from 'embercom/models/data/inbox/searchable-types';
import { cached } from 'tracked-toolbox';

interface Arguments {
  excludedTeamIds?: number[];
  disabledTeamIds?: number[];
  [key: string]: any;
}

interface Signature {
  Args: Arguments;
  Element: HTMLElement;
  Blocks: {
    opener: [];
  };
}

export default class TeamSelector extends Component<Signature> {
  readonly teamEntity = SearchableType.Team;

  @cached
  get disabledTeamIds(): Set<number> {
    return new Set(this.args.disabledTeamIds);
  }

  @action
  isTeamDisabled(teamId: number): boolean {
    if (this.disabledTeamIds.size === 0) {
      return false;
    }

    return this.disabledTeamIds.has(teamId);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::QuickSearch::TeamSelector': typeof TeamSelector;
    'inbox2/common/quick-search/team-selector': typeof TeamSelector;
  }
}
